module.exports = __webpack_public_path__ + "static/bluebox-2-4d672c4e27eb27afba3053c1f31d54b6.png";